(function () {
  var MAX_SENTENCES = 2;
  var MOBILE_MQ = window.matchMedia("(max-width: 1150px)");

  function splitSentences(text) {
    var trimmed = text.replace(/\s+/g, " ").trim();
    if (!trimmed) return [];

    var parts = trimmed.split(/(?<=[.!?])\s+/);
    return parts
      .map(function (part) {
        return part.trim();
      })
      .filter(Boolean);
  }

  function getParagraphs(fullHtml) {
    var wrap = document.createElement("div");
    wrap.innerHTML = fullHtml;
    return Array.prototype.slice.call(wrap.querySelectorAll("p"));
  }

  function countCompleteSentences(text) {
    var normalized = text.replace(/\s+/g, " ");
    var count = 0;
    var re = /[^.!?]*[.!?]+["']?\s*/g;
    while (re.exec(normalized)) {
      count += 1;
    }
    return count;
  }

  function removeNodesAfter(root, node) {
    var parent = node.parentNode;
    while (node.nextSibling) {
      parent.removeChild(node.nextSibling);
    }
    while (parent && parent !== root) {
      while (parent.nextSibling) {
        parent.parentNode.removeChild(parent.nextSibling);
      }
      parent = parent.parentNode;
    }
  }

  function truncateTextNodeToSentences(textNode, root, maxSentences, sentencesSeen) {
    if (sentencesSeen.done) {
      textNode.textContent = "";
      return sentencesSeen;
    }

    var text = textNode.textContent;
    var re = /[^.!?]*[.!?]+["']?\s*/g;
    var match;
    var lastEnd = 0;

    while ((match = re.exec(text)) !== null) {
      sentencesSeen.count += 1;
      lastEnd = re.lastIndex;

      if (sentencesSeen.count >= maxSentences) {
        textNode.textContent = text.substring(0, lastEnd).replace(/\s+$/, "");
        removeNodesAfter(root, textNode);
        sentencesSeen.done = true;
        return sentencesSeen;
      }
    }

    return sentencesSeen;
  }

  function stripPreviewNoise(rootEl) {
    rootEl.querySelectorAll("meta, script, style").forEach(function (node) {
      node.parentNode.removeChild(node);
    });
  }

  function truncateElementToSentences(rootEl, maxSentences) {
    var clone = rootEl.cloneNode(true);
    stripPreviewNoise(clone);
    var state = { count: 0, done: false };

    function walk(node) {
      if (state.done) {
        if (node.parentNode) {
          node.parentNode.removeChild(node);
        }
        return;
      }

      if (node.nodeType === Node.TEXT_NODE) {
        truncateTextNodeToSentences(node, clone, maxSentences, state);
        return;
      }

      if (node.nodeType === Node.ELEMENT_NODE) {
        var child = node.firstChild;
        while (child) {
          var next = child.nextSibling;
          walk(child);
          child = next;
        }
      }
    }

    walk(clone);
    return clone;
  }

  function buildPreviewHtml(fullHtml) {
    var paragraphs = getParagraphs(fullHtml);
    var previewWrap = document.createElement("div");

    if (paragraphs.length >= MAX_SENTENCES) {
      var first = paragraphs[0].cloneNode(true);
      var second = paragraphs[1].cloneNode(true);
      stripPreviewNoise(first);
      stripPreviewNoise(second);
      previewWrap.appendChild(first);
      previewWrap.appendChild(second);
      return previewWrap.innerHTML;
    }

    if (paragraphs.length === 1) {
      if (countCompleteSentences(paragraphs[0].textContent) > MAX_SENTENCES) {
        previewWrap.appendChild(
          truncateElementToSentences(paragraphs[0], MAX_SENTENCES),
        );
        return previewWrap.innerHTML;
      }
      var only = paragraphs[0].cloneNode(true);
      stripPreviewNoise(only);
      previewWrap.appendChild(only);
      return previewWrap.innerHTML;
    }

    var shell = document.createElement("div");
    shell.innerHTML = fullHtml;
    if (countCompleteSentences(shell.textContent) > MAX_SENTENCES) {
      previewWrap.appendChild(truncateElementToSentences(shell, MAX_SENTENCES));
      return previewWrap.innerHTML;
    }

    return null;
  }

  function shouldTruncate(fullHtml, plainText) {
    if (getParagraphs(fullHtml).length > MAX_SENTENCES) return true;
    return countCompleteSentences(plainText) > MAX_SENTENCES;
  }

  function initDescription(el) {
    if (el.dataset.abPdpDescInit === "true") return;

    var fullHtml = el.innerHTML.trim();
    if (!fullHtml) return;

    var plainText = el.textContent || "";
    if (!shouldTruncate(fullHtml, plainText)) return;

    var previewHtml = buildPreviewHtml(fullHtml);
    if (!previewHtml) return;

    el.dataset.abPdpDescInit = "true";

    var previewEl = document.createElement("div");
    previewEl.className = "cc-pdp-desc__preview";
    previewEl.innerHTML = previewHtml;

    var fullEl = document.createElement("div");
    fullEl.className = "cc-pdp-desc__full";
    fullEl.innerHTML = fullHtml;
    fullEl.hidden = true;

    var toggle = document.createElement("button");
    toggle.type = "button";
    toggle.className = "cc-pdp-desc__toggle";
    toggle.textContent = "Read more";

    el.innerHTML = "";
    el.appendChild(previewEl);
    el.appendChild(fullEl);
    el.appendChild(toggle);

    var expanded = false;

    toggle.addEventListener("click", function () {
      expanded = !expanded;
      previewEl.hidden = expanded;
      fullEl.hidden = !expanded;
      toggle.textContent = expanded ? "Read less" : "Read more";
    });
  }

  function getShippingPickupSlot() {
    var root = MOBILE_MQ.matches
      ? document.querySelector(".cc-pdp-accordion.cc-mob-only")
      : document.querySelector(".cc-pdp-left");

    if (!root) return null;
    return root.querySelector(".cc-pdp-acc-shipping .ab-pdp-box-pickup-slot");
  }

  function relocateMobTrustAndAccordion() {
    var home = document.querySelector(".cc-pdp-mob-trust-acc-home");
    var anchor = document.querySelector("[data-ab-mob-trust-acc-anchor]");
    var end = document.querySelector("[data-ab-mob-info-end]");
    if (!home || !anchor || !end) return;

    if (
      document.documentElement.classList.contains("ab-pdp-box") &&
      MOBILE_MQ.matches
    ) {
      end.appendChild(home);
      return;
    }

    anchor.insertAdjacentElement("afterend", home);
  }

  function relocatePickupToShipping() {
    var pickup =
      document.querySelector(".ab-pdp-box-pickup-host pickup-availability") ||
      document.querySelector(".ab-pdp-box-pickup-slot pickup-availability");
    var slot = getShippingPickupSlot();

    if (!pickup || !slot || pickup.parentElement === slot) return;
    slot.appendChild(pickup);
  }

  function syncSoldOutAtcRow() {
    if (!document.documentElement.classList.contains("ab-pdp-box")) return;

    document.querySelectorAll(".cc-pdp-atc-row").forEach(function (row) {
      var submit = row.querySelector('button[name="add"].product-form__submit');
      if (!submit) return;

      var hidden =
        submit.style.display === "none" ||
        window.getComputedStyle(submit).display === "none";

      row.classList.toggle("cc-pdp-atc-row--sold-out", hidden);
    });
  }

  function restoreMobileStickyAtc() {
    if (!MOBILE_MQ.matches) return;

    var stickyBar = document.getElementById("cc-mob-sticky-atc");
    if (stickyBar) {
      stickyBar.removeAttribute("hidden");
    }
  }

  function findFlavoursTarget() {
    return (
      document.getElementById("cc-flavours-inside") ||
      document.querySelector("section.wsi") ||
      document.querySelector(
        ".seller-section.masala.product-more-slide.dekstop",
      ) ||
      document.querySelector(".seller-section.masala.product-more-slide.mobile")
    );
  }

  function initFlavoursLink() {
    document
      .querySelectorAll(".ab-pdp-box-flavours-link")
      .forEach(function (link) {
        if (link.dataset.abFlavoursInit === "true") return;
        link.dataset.abFlavoursInit = "true";

        var target = findFlavoursTarget();
        if (!target) {
          link.hidden = true;
          return;
        }

        link.addEventListener("click", function (e) {
          var section = findFlavoursTarget();
          if (!section) {
            e.preventDefault();
            link.hidden = true;
            return;
          }
          e.preventDefault();
          var offset =
            section.getBoundingClientRect().top + window.scrollY - 120;
          window.scrollTo({ top: offset, behavior: "smooth" });
        });
      });
  }

  function init() {
    if (!document.documentElement.classList.contains("ab-pdp-box")) return;
    restoreMobileStickyAtc();
    relocatePickupToShipping();
    relocateMobTrustAndAccordion();
    syncSoldOutAtcRow();
    document.querySelectorAll(".cc-pdp-desc").forEach(initDescription);
    initFlavoursLink();
  }

  function watchForVariantClass() {
    if (document.documentElement.classList.contains("ab-pdp-box")) {
      init();
      return;
    }

    var observer = new MutationObserver(function () {
      if (document.documentElement.classList.contains("ab-pdp-box")) {
        observer.disconnect();
        init();
      }
    });

    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ["class"],
    });
  }

  function onViewportChange() {
    relocateMobTrustAndAccordion();
    if (!document.documentElement.classList.contains("ab-pdp-box")) return;
    relocatePickupToShipping();
    restoreMobileStickyAtc();
  }

  if (typeof MOBILE_MQ.addEventListener === "function") {
    MOBILE_MQ.addEventListener("change", onViewportChange);
  } else if (typeof MOBILE_MQ.addListener === "function") {
    MOBILE_MQ.addListener(onViewportChange);
  }

  function boot() {
    watchForVariantClass();
    if (
      typeof subscribe === "function" &&
      typeof PUB_SUB_EVENTS !== "undefined"
    ) {
      subscribe(PUB_SUB_EVENTS.variantChange, function () {
        syncSoldOutAtcRow();
      });
    }
    if (window.customElements && customElements.whenDefined) {
      customElements.whenDefined("pickup-availability").then(function () {
        if (document.documentElement.classList.contains("ab-pdp-box")) {
          relocatePickupToShipping();
        }
      });
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
